import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const MacivaManagementHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Maciva"
    text="Éste es el módulo de Gestión de MACIVA."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = (state) => ({
  cards: state.MacivaManagement.get('cards'),
  breadcrumbs: state.MacivaManagement.get('breadcrumbs'),
});

MacivaManagementHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(MacivaManagementHome);
